import { useNavigate } from "react-router-dom";
import { useEffect } from "react";

export default function Welcome() {

  const navigate = useNavigate();

  /* AUTO REDIRECT IF ALREADY LOGGED IN */
  useEffect(() => {

    const token = localStorage.getItem("token");

    if (token) {
      navigate("/today");
    }

  }, [navigate]);

  function startJourney() {

    const token = localStorage.getItem("token");

    if (token) {
      navigate("/today");
    } else {
      navigate("/login");
    }

  }

  return (

    <div
      style={{
        position: "relative",
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        overflow: "hidden"
      }}
    >

      {/* Blurred background */}
      <div
        style={{
          position: "absolute",
          inset: 0,
          backgroundImage: "url('/Chi-Rho.jpg')",
          backgroundSize: "cover",
          backgroundPosition: "center",
          filter: "blur(10px)",
          transform: "scale(1.1)"
        }}
      />

      {/* Dark overlay */}
      <div
        style={{
          position: "absolute",
          inset: 0,
          background: "rgba(0,0,0,0.35)"
        }}
      />

      {/* Content */}
      <div
        style={{
          position: "relative",
          textAlign: "center",
          color: "white",
          display: "flex",
          flexDirection: "column",
          alignItems: "center"
        }}
      >

        {/* Sacred card */}
        <div
          style={{
            borderRadius: "18px",
            overflow: "hidden",
            boxShadow: "0 15px 40px rgba(0,0,0,0.45)",
            marginBottom: "2rem"
          }}
        >
          <img
            src="/Chi-Rho.jpg"
            alt="Chi-Rho"
            style={{
              width: "220px",
              display: "block"
            }}
          />
        </div>

        <h1
          style={{
            fontSize: "48px",
            letterSpacing: "6px",
            fontFamily: "Cormorant Garamond, serif",
            marginBottom: "10px"
          }}
        >
          PAX ORDINIS
        </h1>

        <p
          style={{
            fontSize: "18px",
            lineHeight: "1.6",
            marginBottom: "30px"
          }}
        >
          Peace through Order
          <br/>
          centered on Christ
        </p>

        <button
          onClick={startJourney}
          style={{
            padding: "14px 28px",
            fontSize: "18px",
            borderRadius: "10px",
            border: "none",
            backgroundColor: "#4c6f91",
            color: "white",
            cursor: "pointer"
          }}
        >
          Start Your Journey
        </button>

      </div>

    </div>

  );

}
